import type { Track } from "@similarweb/tracking-provider";

import type { DemoId } from "app/pages/sales-intelligence/types/demo-mode";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

const demoExitTriggerMap = {
    bannerClose: "banner close",
    returnCta: "return cta",
} as const;

type DemoExitTrigger = (typeof demoExitTriggerMap)[keyof typeof demoExitTriggerMap];

export default function createDemoModeTrackingService(track: Track) {
    const trackExit = (demoId: DemoId, trigger: DemoExitTrigger): void => {
        track("demo mode", "exit", createTrackingEventName(trigger, demoId));
    };

    return {
        trackDemoEnterClick(demoId: DemoId) {
            track("demo mode", "enter", createTrackingEventName(demoId));
        },
        trackBannerCtaClick(demoId: DemoId) {
            track("demo mode", "click on cta", createTrackingEventName(demoId));
        },
        trackBannerCloseClick(demoId: DemoId) {
            trackExit(demoId, demoExitTriggerMap.bannerClose);
        },
        trackDemoReturnClick(demoId: DemoId) {
            trackExit(demoId, demoExitTriggerMap.returnCta);
        },
    };
}
